import { Component, Injectable } from "@angular/core";
import { SignalsMainComponent } from "./main.component";

@Component({
  selector: "app-signals-insights",
  template: `<app-signals-messages [isScheduled]='false' title="Messages"></app-signals-messages>`,
  styleUrls: ["../styles/signalsMessages.component.css"],
})
@Injectable()
export class SignalsInsightsComponent extends SignalsMainComponent {
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/components/scripts/signalsInsights.component.ts